import { reducer as authReducer } from './slice';

export * from './actions';
export * from './middlewares';

export default authReducer;
